import {defaultProduct} from "./defaultProduct";

const initialState = {
  loading: true,
  oos: true,
  oosWithInfo: false,
  info: defaultProduct,
  imageSlider: false,
  engraving: {
    active: false,
    msg: {
      line1: '',
      line2: '',
      line3: '',
      line4: ''
    }
  },
  bundle: {
    active: false,
  },
  details: [
    {
      title: 'About',
      details: 'The Macallan Double Cask 12-Year-Old pairs the indulgent fruit, caramel, and oak spice character of Sherry-seasoned European oak with the bright citrus and vanilla notes of Sherry-seasoned American oak for a satisfyingly rich and perfectly balanced flavor experience. Awarded unanimous Double Gold upon release. Deliciously smooth, with rich dried fruits and sherry, balanced with woodsmoke and spice. Described by Max Stose, the renowned international whisky writer, in his book Kindred Spirits as \'simply the best 12 Year Old single malt around.',
    },
    {
      title: 'Product Details',
      details: `
        <div> 
          <p style="margin-bottom: 5px;">
            <p><span style="font-weight: bold; margin-right: 5px;">Category: </span> Whiskey</p>
          </p>
          <p style="margin-bottom: 5px;">
            <p> <span style="font-weight: bold; margin-right: 5px;">Origin: </span> Scottland, Speyside</p>
          </p>
          <p style="margin-bottom: 5px;">
            <p><span style="font-weight: bold; margin-right: 5px;">ABV: </span> 40%</p>
          </p>
        </p>
      `
    },
    {
      title: 'Restrictions',
      details: 'California residents: Click here for Proposition 65 WARNING'
    }
  ],
  quantity: 1,
  selection: defaultProduct.sizes[0],
  seeMore: false,
  width: 0
}

export default initialState
